<template>
  <div>
    <p>L’atténuation de la chaleur ressentie dans les bâtiments ne dépend pas uniquement des améliorations à apporter sur les structures ou sur les équipements : nos comportements jouent un rôle essentiel dans la recherche du confort et doivent évoluer dans le bon sens.</p>
    <p>Par exemple, l’ouverture des fenêtres permet une meilleure circulation de l’air en deuxième partie de nuit jusqu’à l’aube (température les plus fraiches).</p>
  </div>
</template>